import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Rotas} from "src/app/core/rotas";
import {BaseService} from "../base/base.service";
import {Rim} from "../../core/rim";

@Injectable({
    providedIn: "root",
})
export class RimService extends BaseService<Rim> {
    constructor(http: HttpClient) {
        super(http, Rotas.RIM);
    }

    showRelatorio(idRim: number, tipoArquivo: string): any {
        return this.http.get(Rotas.RIM + "gerarRelatorio", {
            params: {
                idRim: `${idRim}`,
                tipoArquivo: `${tipoArquivo}`,
            },
            responseType: 'arraybuffer'
        });
    }

    getFilter(idUnidade: string | number,
              dataInicio: number,
              dataFim: number,
              idContrato: string | number) {
        const params: any = {};

        if (idUnidade) params.unidade = idUnidade;
        if (dataInicio) params.dataInicio = dataInicio;
        if (dataFim) params.dataFim = dataFim;
        if (idContrato) params.contrato = idContrato;

        return this.http.get(Rotas.RIM + "filter", {params});
    }

    alterarModeloPadrao(idRim: number) {
        return this.http.post(Rotas.RIM + "alterarModeloPadrao", idRim);
    }

    finalizar(idRim: number) {
        return this.http.post(Rotas.RIM + "finalizar", idRim);
    }

}
